import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-050f4438"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-left":"20px","font-weight":"600","text-align":"center","font-size":"18px","margin-bottom":"10px"} }, [
  /*#__PURE__*/_createTextVNode(" 每日人均产能统计"),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "（作为工资提成依据）")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-left":"20px"} }, " 统计对象：任务类型等于计量任务，且开始时间与结束时间为同一天的任务。", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-left":"20px"} }, " 统计内容：点击 “提交计量数据” 的数字（当天完成量）", -1))
const _hoisted_4 = { class: "main_project" }
const _hoisted_5 = { class: "list_search" }
const _hoisted_6 = { class: "search_header" }
const _hoisted_7 = {
  class: "flexWrap",
  style: {"width":"80%"}
}
const _hoisted_8 = { class: "header_nr flexAlign" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nr_left",
  style: {"width":"82px"}
}, "开始时间：", -1))
const _hoisted_10 = { class: "header_nr flexAlign" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nr_left",
  style: {"width":"82px"}
}, "截止时间：", -1))
const _hoisted_12 = {
  class: "header_twonr",
  style: {"margin-top":"20px"}
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_14 = { class: "my-header" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "添加", -1))
const _hoisted_16 = { class: "my-header" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Excel导入", -1))

import { CirclePlus,Search } from '@element-plus/icons-vue';
	import { reactive,ref,onMounted,nextTick } from 'vue';
	import AddUser from '@/components/AddUser.vue';
	import { requestJlrw,requestDDDepartlist } from '@/api/xmApi';
	import { ElMessage } from 'element-plus';
	import Excel from '@/components/Excel'
	
export default /*#__PURE__*/_defineComponent({
  name: 'jlrwtj',
  setup(__props) {

	const loading = ref(false)
	const tableData = ref([])
	const pageIndex = ref(1)
	const pageSize = ref(10)
	const pages = ref({
		totalCount:0
	})
	const search = ref({
		startdate1:'',
		startdate2:''
	})//搜索
	const DDDepartlist= ref([])
	const addShow = ref(false)
	const userShow = ref(false)
	const exceladdShow = ref<boolean>(false)
	const excelShow= ref<boolean>(false)
	const uuid = ref("")
	const dddepartid=ref("")
	onMounted(()=>{
		getUserList();
		getDDDepartlist();
	})
	const getDDDepartlist = () =>{
		requestDDDepartlist({}).then((res:any)=>{
			DDDepartlist.value=res.datalist;
			console.log(DDDepartlist.value);
		})
	}
	
	const getUserList = () =>{
		loading.value = true
		requestJlrw({
			startdate1:search.value.startdate1,
			startdate2:search.value.startdate2
		}).then((res:any)=>{
			tableData.value = res.datalist
			loading.value = false
		})
	}
	
	//提交成功后
	const cancel = (val: any) => {
		addShow.value = false
		if(val){
			getUserList();
		}
	}
	
	const handleSizeChange = (val: number) =>{
		pageSize.value = val
		getUserList();
	}
	const handleCurrentChange = (val: number) =>{
		pageIndex.value = val
		getUserList();
	}
	const searchList = () =>{
		pageIndex.value = 1
		getUserList();
	}

	
	const excelsx = () =>{
		excelShow.value = false
		nextTick(()=>{
			excelShow.value = true
		})
	}
	const excelcancel = () => {
		exceladdShow.value = false
		getUserList();
	}
	const exceladd = ()=>{
		excelsx();
		exceladdShow.value = true
	}

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_Close = _resolveComponent("Close")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_el_date_picker, {
                modelValue: search.value.startdate1,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search.value.startdate1) = $event)),
                type: "date",
                placeholder: "开始时间",
                "value-format": "YYYY-MM-DD"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_el_date_picker, {
                modelValue: search.value.startdate2,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search.value.startdate2) = $event)),
                type: "date",
                placeholder: "截止时间",
                "value-format": "YYYY-MM-DD"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_el_button, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (searchList())),
              size: "small",
              icon: _unref(Search),
              type: "primary",
              plain: ""
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            }, 8, ["icon"])
          ])
        ])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        onCellClick: _ctx.details,
        "empty-text": "暂无数据",
        data: tableData.value,
        "header-cell-style": {color:'#000',backgroundColor:'#fafbfd'}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            type: "index",
            width: "80",
            label: "序号",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "operatorname",
            label: "姓名",
            width: "120"
          }),
          _createVNode(_component_el_table_column, {
            prop: "maxjl",
            label: "当期任务总数",
            width: "120"
          }),
          _createVNode(_component_el_table_column, {
            prop: "wcjl",
            label: "当期完成数",
            width: "120"
          }),
          _createVNode(_component_el_table_column, {
            prop: "wcl",
            label: "任务率",
            width: "120"
          }),
          _createVNode(_component_el_table_column, {
            prop: "summaxjlgs",
            label: "任务总时间",
            width: "120"
          }),
          _createVNode(_component_el_table_column, {
            prop: "wcjlgs",
            label: "任务完成时间",
            width: "120"
          }),
          _createVNode(_component_el_table_column, {
            prop: "cnl",
            label: "人均产能完成率",
            width: "120"
          })
        ]),
        _: 1
      }, 8, ["onCellClick", "data"])), [
        [_directive_loading, loading.value]
      ]),
      _createVNode(_component_el_dialog, {
        title: "添加",
        modelValue: addShow.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((addShow).value = $event)),
        "show-close": false,
        "close-on-click-modal": false
      }, {
        header: _withCtx(({ close, titleId, titleClass }) => [
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(_component_el_icon, {
              class: "delicon",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (addShow.value=false))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Close)
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          (userShow.value)
            ? (_openBlock(), _createBlock(AddUser, {
                key: 0,
                onCancel: cancel,
                uuid: uuid.value
              }, null, 8, ["uuid"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        title: "Excel导入",
        modelValue: exceladdShow.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((exceladdShow).value = $event)),
        "show-close": false
      }, {
        header: _withCtx(({ close, titleId, titleClass }) => [
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createVNode(_component_el_icon, {
              class: "delicon",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (exceladdShow.value=false))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Close)
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          (excelShow.value)
            ? (_openBlock(), _createBlock(_unref(Excel), {
                key: 0,
                onCancel: _cache[6] || (_cache[6] = ($event: any) => (excelcancel())),
                id: "用户导入"
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ], 64))
}
}

})